import NodesDataView from "./NodesDataView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SearchPhoneLines from "./SearchNodes";


const defaultFilterData: INodeSearchForm = {
  description: ""
}

const Nodes = () => {
  
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView  title="Αναζήτηση κόμβου">
        <SearchPhoneLines />
      </SydFilterView>

      <NodesDataView />
    </SydFilterProvider>
  )

}
export default Nodes;

